import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {Api} from '../enum/Api';
import {map} from 'rxjs/operators';

@Injectable()
export class AdyenService {

  constructor(
    private httpService: HttpService,
  ) {}

  public getClientKey(): Observable<any> {
    return this.httpService.post('integration/adyen/getClientKey', Api.One_Portal, {
      //No params required.
    });
  }

  public getAdyenConfig(productId: string, productClassification: string, userId: string): Observable<any> {
    return this.httpService.post('serasa/adyenSaleConfig/getAdyenConfig', Api.One_Portal,
      {
        'productId': productId,
        'productClassification': productClassification,
        'userId': userId
      }).pipe(map(result => (result.isAdyen)))
  }
}